<template>
  <div class="Carrousel__Container">
    <div class="Carrousel__Carrousel">
      <!--
      <div
        class="Carrousel__Arrow Carrousel__ArrowLeft"
        @click="Previous()"
      />
      -->
      <div
        v-for="(tab, index) in GetTables()"
        :key="index"
        class="Carrousel__Item"
        :style="{ backgroundImage: `url(${GetImage(previewtop ? tab.previewTop : tab.preview)})`}"
        @click="SelectTable(tab)"
      >
        <div class="Carrousel__ItemBlock">
          <div class="Carrousel__ItemTitle">
            <p
              class="Carrousel__ItemTitleText"
              :style="tab === table ? 'font-weight: 600' : 'font-weight: 200'"
            >
              {{ tab.type === 'round' ? $t('table-circular') : $t('table-rectangular') }}
            </p>
          </div>
          <div
            class="Carrousel__ItemDimensions"
            v-if="$store.getters.selectedLang === 'en-US'"
          >
            <div
              class="Carrousel__DimensionsColumn"
              v-if="tab.type==='round'"
            >
              <span
                class="Carrousel__ItemDimensionsText"
                :style="tab === table ? 'font-weight: 600' : 'font-weight: 200'"
              >{{ tab.diameter.imperial }} Dia.</span>
              <span
                class="Carrousel__ItemDimensionsText"
                :style="tab === table ? 'font-weight: 600' : 'font-weight: 200'"
              >Ø {{ tab.diameter.metric }} cm</span>
            </div>
            <div
              v-if="tab.type==='rectangular'"
              class="Carrousel__DimensionsColumn"
            >
              <span
                class="Carrousel__ItemDimensionsText"
                :style="tab === table ? 'font-weight: 600' : 'font-weight: 200'"
              >{{ tab.length.imperial }} {{ $t('length') }}. x {{ tab.width.imperial }} {{ $t('depth') }}.</span>
              <span
                class="Carrousel__ItemDimensionsText"
                :style="tab === table ? 'font-weight: 600' : 'font-weight: 200'"
              >{{ $t('length') }}. {{ tab.length.metric }} x {{ $t('depth') }}. {{ tab.width.metric }} cm </span>
            </div>
          </div>
          <div
            class="Carrousel__ItemDimensions"
            v-else
          >
            <div
              class="Carrousel__DimensionsColumn"
              v-if="tab.type==='round'"
            >
              <span
                class="Carrousel__ItemDimensionsText"
                :style="tab === table ? 'font-weight: 600' : 'font-weight: 200'"
              >Ø {{ tab.diameter.metric }} cm</span>
              <span
                class="Carrousel__ItemDimensionsText"
                :style="tab === table ? 'font-weight: 600' : 'font-weight: 200'"
              >{{ tab.diameter.imperial }} Dia.</span>
            </div>
            <div
              v-if="tab.type==='rectangular'"
              class="Carrousel__DimensionsColumn"
            >
              <span
                class="Carrousel__ItemDimensionsText"
                :style="tab === table ? 'font-weight: 600' : 'font-weight: 200'"
              >{{ $t('length') }}. {{ tab.length.metric }} x {{ $t('depth') }}. {{ tab.width.metric }} cm </span>
              <span
                class="Carrousel__ItemDimensionsText"
                :style="tab === table ? 'font-weight: 600' : 'font-weight: 200'"
              >{{ tab.length.imperial }} {{ $t('length') }}. x {{ tab.width.imperial }} {{ $t('depth') }}.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tables from '@/settings/tables.json'
import { mapGetters } from 'vuex'
import { EventBus } from '@/event-bus.js'

export default {
  computed: {
    ...mapGetters(['table'])
  },
  props: {
    previewtop: { type: Boolean }
  },
  mounted () {
    EventBus.$on('SetTableFromURL', () => {
      if (this.$route.query.table) {
        for (let i = 0; i < tables.length; i++) {
          if (tables[i].id === this.$route.query.table.toUpperCase()) {
            this.$store.dispatch('SetTable', tables[i])
            return
          }
        }
      }
      this.SelectTable(tables[0])
      this.$store.dispatch('SetTable', tables[0])
    })
  },
  beforeDestroy () {
    EventBus.$off('SetTableFromURL')
  },
  methods: {
    GetTables () {
      return tables
    },
    GetImage (name) {
      return require('@/assets/tables/' + name)
    },
    SelectTable (table) {
      this.$store.dispatch('SetTable', table)
    },
    Previous () {
      const index = this.GetIndex()
      if (index === -1) return
      if (index - 1 < 0) {
        this.$store.dispatch('SetTable', tables[tables.length - 1])
      } else {
        this.$store.dispatch('SetTable', tables[index - 1])
      }
    },
    Next () {
      const index = this.GetIndex()
      if (index === -1) return
      if (index + 1 >= tables.length) {
        this.$store.dispatch('SetTable', tables[0])
      } else {
        this.$store.dispatch('SetTable', tables[index + 1])
      }
    },
    GetIndex () {
      for (let i = 0; i < tables.length; i++) {
        if (tables[i] === this.table) {
          return i
        }
      }
      return -1
    }
  }
}
</script>

<style>
.Carrousel__Container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
}

.Carrousel__Carrousel{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.Carrousel__Arrow {
    align-self: center;
    width: 40px;
    height: 40px;
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
    background: black;
    pointer-events: auto;
}

.Carrousel__ArrowLeft{
    mask-image: url('../../../assets/icons/chevron-left.svg');
}

.Carrousel__ArrowRight{
    mask-image: url('../../../assets/icons/chevron-right.svg');
}
@media screen and (min-width: 1300px) {
.Carrousel__Item{
    align-self: center;
    width: 150px;
    height: 150px;
    margin-top: -1.5em;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    pointer-events: auto;
    align-self: flex-start;
    display:flex;
    justify-content: center;
}
.Carrousel__ItemBlock{
  margin-top: 125px;
  align-self: center;
}
}
@media screen and (max-width: 1300px) {
.Carrousel__Item{
    align-self: center;
    width: 120px;
    height: 120px;
    margin-top: 0.3em;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    pointer-events: auto;
    align-self: flex-start;
    display:flex;
    justify-content: center;
}
.Carrousel__ItemBlock{
  margin-top: 110px;
  align-self: center;
}
}

.Carrousel__DimensionsColumn{
  display: flex;
  flex-direction: column;
}

.Carrousel__Selected{
    width: 180px;
    height: 180px;
}

.Carrousel__ItemTitle {

}

.Carrousel__ItemDimensions {
display: flex;
justify-content: center;
}

.Carrousel__ItemTitleText {
 text-align: center;
 font-size: 0.8em;
 margin-top: 0.4em;
 margin-bottom: 0.5em;
}

.Carrousel__ItemDimensionsText {
 text-align: center;
 margin-top: 0.2em;
 font-size: 0.7em;
}

.Carrousel__ItemDimensionsTextBold {
   text-align: center;
 margin-top: 0.5em;
 font-size: 0.7em;
 font-weight: 400;
}
</style>
